import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'

export class FilterIdSearchValueObject extends ValueObject {
  #id

  constructor({id}) {
    super()
    this.#id = id
  }

  static create({id}) {
    return new FilterIdSearchValueObject({id: NumberSharedValueObject.create({value: id})})
  }

  get isEmpty() {
    return !this.#id.value
  }

  get value() {
    return this.#id.value
  }

  toJSON() {
    return {id: this.#id.toJSON()}
  }
}
